module.exports = __webpack_public_path__ + "static/img/pexels-photo-239898.087576b.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sources/pexels-photo-239898.jpeg
// module id = PA+7
// module chunks = 1